const Recepcion = ({}) => {
  return <div>Hola Recepcion</div>;
};
export default Recepcion;
